export const BACK_TITLE = 'Back to Account Management';

export const PRIMARY_CARE_PROVIDER = 'Primary Care Provider (PCP)';
export const PRIMARY_CARE_PROVIDER_TITLE = 'Your Primary Care Provider (PCP)';
export const PRIMARY_CARE_PROVIDER_BODY = 'SANDS CONSTELLATION HEART INSTITUTE';
export const PRIMARY_CARE_PROVIDER_DEPENDENT =
  'Your Dependent’s PCP Information';
export const PRIMARY_CARE_PROVIDER_DEPENDENT_CONTENT =
  'You can only view your dependent’s PCP. If you need to set a PCP for your dependents, please call the Member Service number on the back of your ID card. You and your dependents can each choose a different PCP.';
export const PRIMARY_CARE_PROVIDER_DEPENDENT1 = "Jourdin B Beyman's PCP";
export const PRIMARY_CARE_PROVIDER_DEPENDENT2 = "Jerrel L Beyman's PCP";
export const PRIMARY_CARE_PROVIDER_DEPENDENT1_GROUP1 = 'STRONG MEDICAL GROUP';
export const PRIMARY_CARE_PROVIDER_DEPENDENT3 = "Depsix Beyman's PCP";
export const PRIMARY_CARE_PROVIDER_DEPENDENT2_GROUP2 = 'No PCP on file.';
export const PRIMARY_CARE_PROVIDER_CONTENT_TITLE = 'Selecting Your PCP';
export const PRIMARY_CARE_PROVIDER_CONTENT_BODY1 = ' Search for your provider';
export const PRIMARY_CARE_PROVIDER_CONTENT_BODY2 =
  ' on the Sapphire Digital website.';
export const PRIMARY_CARE_PROVIDER_KYRUUS_CONTENT_BODY =
  ' on the Kyruus website.';
export const PRIMARY_CARE_PROVIDER_CONTENT_BODY3 =
  " Click ‘Select as your PCP'";
export const PRIMARY_CARE_PROVIDER_CONTENT_BODY4 =
  ' to register them as your official PCP. You can also replace a previously listed PCP by selecting a new one.';
export const PRIMARY_CARE_PROVIDER_CONTENT1 = 'Note:';
export const PRIMARY_CARE_PROVIDER_CONTENT2 =
  ' Only providers in western Pennsylvania, central Pennsylvania, northeastern New York, western New York, Delaware, and West Virginia can be selected as a PCP.';

export const SERVICE_DOWN =
  'Our system has run into some issues while gathering your information. Please try again later or call Customer Service.';
export const PLAN_CANCELLED = 'Plan cancelled on MM/DD/YYYY';
/** tooltip contents */

export const PRIMARY_CARE_PROVIDER_TITLE_TOOLTIP = `A PCP or Physician of Record is a primary care doctor who takes care of routine and preventive care such as physicals, immunizations, and screenings. Your PCP/POR also coordinates care among other providers, including specialists and hospitals. </br> </br> You don't need a referral from your PCP/POR to see specialists or to get treatment.</br></br> Having or not having a PCP/POR doesn't affect your benefits or claims payments. It helps us serve you better by connecting you with the provider who delivers most of your care. You’re still able to change your PCP/POR at any time.`;

export const PRIMARY_CARE_PROVIDER_SUB_TITLE_TOOLTIP =
  'Your PCP may appear as the name of the practice where you get care instead of the name of your doctor.';
export const PRIMARY_CARE_PROVIDER_NOPCP_TOOLTIP =
  'Call customer service to set a PCP for your dependent.';

export const PRIMARY_CARE_PROVIDER_ATTENSIONBOX_TITLE = 'Attention';
export const PRIMARY_CARE_PROVIDER_ATTENSIONBOX_SUB_TITLE =
  'You will be redirected to the Sapphire Digital site';
export const PRIMARY_CARE_PROVIDER_ATTENSIONBOX_SUB_TITLE_KYRUUS =
  'You will be redirected to the Kyruus site';
export const PRIMARY_CARE_PROVIDER_ATTENSIONBOX_BODY =
  'This link will bring you to a third-party website, owned and operated by an independent party over which your plan’s website has no control. Any use of the third-party website and any information you provide will be subject to and governed by the terms of the third-party website, including those relating to confidentiality, data privacy and security.';

/* sapprie link */

export const SAPPHIRE_LINK =
  'https://uat.highmark.sapphirecareselect.com/?network_id=152&geo_location=37.389255,-81.023957&locale=en&ci=balance-ppo-hmbcbswv';

export const KYRUUS_LINK = 'https://uat.findcare.app/healthsparq/#/one/auth';
